var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BAlert',_vm._b({staticClass:"fr-alert",scopedSlots:_vm._u([{key:"dismiss",fn:function(){return [_c('i',{staticClass:"fr-alert-dismiss material-icons"},[_vm._v(" close ")])]},proxy:true}])},'BAlert',_vm.$props,false),[_c('i',{staticClass:"material-icons-outlined mr-2"},[_vm._v(" "+_vm._s(_vm.alertIcon)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }